import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bau365-watchlist-filter-button',
  templateUrl: './watchlist-filter-button.component.html',
})
export class WatchlistFilterButtonComponent {
  @Input() screen: string | undefined | null;
  @Input() markAsActive: boolean | undefined | null;
  @Output() filterButtonClicked = new EventEmitter<boolean>();

  onFilterButtonClicked() {
    this.filterButtonClicked.emit(true);
  }
}
